function updateButtonTextFromDiv() {
  const selectedDiv = document.querySelector('.recurpay__widget_container--selected');
  const buttonSpan = document.querySelector('button.product-form__submit span');
  if (!selectedDiv || !buttonSpan) return;

  const type = selectedDiv.getAttribute('data-type');
  buttonSpan.textContent = (type === 'subscription-purchase')
    ? 'Start Subscription'
    : 'Add to cart';
}

// Use event delegation (fires once per click)
document.addEventListener('click', (e) => {
  const container = e.target.closest('.recurpay__widget_container');
  if (container) {
    // Wait for class update before reading data-type
    setTimeout(updateButtonTextFromDiv, 150);
  }
});

// Run once after the widget is first loaded — observer stops itself
const observer = new MutationObserver((mutations, obs) => {
  const widget = document.querySelector('.recurpay__widget');
  if (widget) {
    updateButtonTextFromDiv();
    obs.disconnect(); // prevent infinite loop
  }
});

observer.observe(document.body, { childList: true, subtree: true });
